type AgreementSignerLike = {
    relatedResource?: string;
    name?: string;
    firstname?: string;
    lastname?: string;
};

const asRecord = (value: unknown): Record<string, unknown> | null =>
    value && typeof value === "object" && !Array.isArray(value) ? (value as Record<string, unknown>) : null;

const asNonEmptyString = (value: unknown): string | undefined =>
    typeof value === "string" && value.trim() !== "" ? value : undefined;

const composePersonName = (...parts: unknown[]) =>
    parts
        .map(asNonEmptyString)
        .filter((part): part is string => !!part)
        .join(" ");

const getBeneficiarySigner = (signers?: AgreementSignerLike[] | number) =>
    Array.isArray(signers) ? signers.find((signer) => signer.relatedResource === "beneficiary") : undefined;

export const getFallbackAgreementVariableValue = (
    key: string,
    agreementValues: Record<string, unknown>,
    signers?: AgreementSignerLike[] | number,
): string | undefined => {
    const direct = asNonEmptyString(agreementValues[key]);
    if (direct) return direct;

    const mainBeneficiary = asRecord(
        Array.isArray(agreementValues.beneficiaries) ? agreementValues.beneficiaries[0] : null,
    );
    const fromBeneficiary = asNonEmptyString(mainBeneficiary?.[key]);
    if (fromBeneficiary) return fromBeneficiary;

    const beneficiarySigner = getBeneficiarySigner(signers);

    if (key === "name") {
        return (
            composePersonName(agreementValues.firstName, agreementValues.lastName) ||
            composePersonName(mainBeneficiary?.firstName, mainBeneficiary?.lastName) ||
            composePersonName(beneficiarySigner?.firstname, beneficiarySigner?.lastname) ||
            asNonEmptyString(beneficiarySigner?.name)
        );
    }
    if (key === "firstName") return asNonEmptyString(beneficiarySigner?.firstname);
    if (key === "lastName") return asNonEmptyString(beneficiarySigner?.lastname);

    return undefined;
};
